// extracted by mini-css-extract-plugin
export default {"collapsibleTable":"PrintOptionRateTable_collapsibleTable__kIbXb"};